import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.75 6.5C12.75 6.08579 12.4142 5.75 12 5.75C11.5858 5.75 11.25 6.08579 11.25 6.5V11.75H6C5.58579 11.75 5.25 12.0858 5.25 12.5C5.25 12.9142 5.58579 13.25 6 13.25H11.25V18.5C11.25 18.9142 11.5858 19.25 12 19.25C12.4142 19.25 12.75 18.9142 12.75 18.5V13.25H18C18.4142 13.25 18.75 12.9142 18.75 12.5C18.75 12.0858 18.4142 11.75 18 11.75H12.75V6.5Z",
		fill: "black"
	})
});
export default SvgAdd;
